import { PersonIcon } from '@assets/icons';
import ResponsiveSearchDrawerItem from '@components/views/components/listing/drawer/ResponsiveSearchDrawerItem';
import {
  FlightGuestProps,
  FlightSearchBarProps,
  FlightSearchInputDrawerType,
} from '@components/views/flight/types';
import ResponsiveApplyButton from '@components/views/components/listing/drawer/ResponsiveApplyButton/ResponsiveApplyButton';
import ResponsiveSearchInputDrawer from '@components/views/components/listing/drawer/ResponsiveSearchInputDrawer/ResponsiveSearchInputDrawer';
import { getGuestText } from '@components/views/flight/utils';

import FlightGuestBox from './FlightGuestBox';
import useFlightGuests from './useFlightGuests';

const ResponsiveFlightGuestBoxDrawer = ({
  guestInfo,
  onApplyGuestsForm,
  title,
  subTitle,
  placeholder,
  drawerTitle,
  arrowIcon,
}: {
  guestInfo: FlightGuestProps;
} & Pick<FlightSearchBarProps, 'onApplyGuestsForm'> &
  FlightSearchInputDrawerType) => {
  return (
    <ResponsiveSearchInputDrawer
      icon={PersonIcon}
      title={title}
      subTitle={subTitle}
      placeholder={placeholder}
      drawerTitle={drawerTitle}
      arrowIcon={arrowIcon}
    >
      {(hideModal) => (
        <ResponsiveFlightGuestBox
          guestInfo={guestInfo}
          onApplyGuestsForm={onApplyGuestsForm}
          hideModal={hideModal}
        />
      )}
    </ResponsiveSearchInputDrawer>
  );
};

const ResponsiveFlightGuestBox = ({
  guestInfo,
  onApplyGuestsForm,
  hideModal,
}: {
  guestInfo: FlightGuestProps;
  hideModal: () => void;
} & Pick<FlightSearchBarProps, 'onApplyGuestsForm'>) => {
  const {
    numberOfAdultGuests,
    numberOfChildGuests,
    numberOfInfantGuests,
    removeAdult,
    addAdult,
    removeChild,
    addChild,
    removeInfant,
    addInfant,
    errorMessages,
  } = useFlightGuests(guestInfo);
  return (
    <>
      <ResponsiveSearchDrawerItem
        icon={PersonIcon}
        title='Kaç kişi yolculuk yapacaksınız?'
        subTitle={getGuestText({
          numberOfAdultGuests,
          numberOfChildGuests,
          numberOfInfantGuests,
        })}
        placeholder='Yolcu Seçimi'
      />

      <FlightGuestBox
        numberOfAdultGuests={numberOfAdultGuests}
        numberOfChildGuests={numberOfChildGuests}
        numberOfInfantGuests={numberOfInfantGuests}
        onRemoveAdult={removeAdult}
        onAddAdult={addAdult}
        onRemoveChild={removeChild}
        onAddChild={addChild}
        onRemoveInfant={removeInfant}
        onAddInfant={addInfant}
        errorMessages={errorMessages}
      />

      <ResponsiveApplyButton
        onClick={() => {
          onApplyGuestsForm({
            numberOfAdultGuests,
            numberOfChildGuests,
            numberOfInfantGuests,
          });
          hideModal();
        }}
      />
    </>
  );
};

export default ResponsiveFlightGuestBoxDrawer;
